<div [ngClass]="{'light-theme': true, 'dashboard-header': (showPendingTasks || showStatus)}">
    <div class="container-fluid">
        <div [ngClass]="{'row ':true, ' align-items-end ': pendingTask}">
            <div [ngClass]="{'col-12 ':true, ' col-lg-6 ': !pendingTask}">
                <div class="{{titleCssIcon}} dashboard-header-title py-4">
                    <h1 class="pl-2">{{title}}</h1>
                </div>
            </div>
            <div class="col-12 col-lg-6 position-relative journey-status" *ngIf="showStatus">
                <status [userStatus]="userStatus" [activitiesCount]="activitiesCount"></status>
            </div>
            <div class="col-12 col-lg-6 py-4 dashboard-header-tasks-container" *ngIf="!completedTasksDismissed && showPendingTasks">
                <h3 class="pb-3"><i>Getting Started</i></h3>
                <div class="row ">
                    <div class="col-12">
                        <div class="dashboard-header-task d-flex align-items-center py-2"
                            *ngFor="let task of tasks; let i=index">
                            <svg *ngIf="!task.completed" width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16" cy="16" r="15.625" stroke="black" stroke-width="0.75" />
                            </svg>
                            <svg *ngIf="task.completed" width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16" cy="16" r="15.625" fill="black" stroke="black" stroke-width="0.75" />
                                <path d="M24 10L13 21L8 16" stroke="white" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                            <span class="pl-3 text-large">{{task.name}}</span>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="!pendingTask && !completedTasksDismissed">
                    <div class="col-12">
                        <div><span class="text-large font-weight-bold"></span> You’ve finished your getting started tasks!</div>
                    </div>
                    <div class="col-12">
                        <a role="button" class="btn btn-secondary" (click)="onDismissTasks()">DISMISS</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>